import client from './client';

export function listEvents(params) {
  return client.get('/events', { params });
}

export function getEvent(id) {
  return client.get(`/events/${id}`);
}

export function listCourses(params) {
  return client.get('/courses', { params });
}

export function getCourse(id) {
  return client.get(`/courses/${id}`);
}

export function listClubs(params) {
  return client.get('/clubs', { params });
}

export function getClub(id) {
  return client.get(`/clubs/${id}`);
}

export function listNews(params) {
  return client.get('/news', { params });
}

export function getNews(id) {
  return client.get(`/news/${id}`);
}

// 会员相关
export function listPlayers(params) {
  return client.get('/players', { params });
}

export function getPlayer(id) {
  return client.get(`/players/${id}`);
}

// 规则
export function getAllRules(params = {}) {
  return client.post('/rules/getAll', params);
}

// 地图 & 布局相关（使用 web 路由）
export function getCoursesMapAll() {
  return client.get('/courses/map');
}

export function getLayoutWithHoles(layoutId) {
  return client.get(`/courses/layouts/${layoutId}`);
}
